import { CONSTANTS } from 'config';

export default function () {

  return function designType(type = '') {
    if (CONSTANTS.PROJECT_TYPE[type]) {
      return CONSTANTS.PROJECT_TYPE[type].name;
    }
    return '';
  };
}



// WEBPACK FOOTER //
// ./src/filters/designType.js